export default __webpack_public_path__ + "static/media/Vanir Fleshcarver.2490142f.jpg";